// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.13.0 (commit 38257d71b4072ad09dadeee8a953b99947cbc761).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AddStepToOrientationReducer from "./add_step_to_orientation_reducer";
import AddUserReducer from "./add_user_reducer";
import AdvanceAssignmentReducer from "./advance_assignment_reducer";
import AdvanceGroupRunReducer from "./advance_group_run_reducer";
import ArchiveCohortReducer from "./archive_cohort_reducer";
import ArchiveCohortFinishLiveReducer from "./archive_cohort_finish_live_reducer";
import ArchiveUserReducer from "./archive_user_reducer";
import AssignCohortReducer from "./assign_cohort_reducer";
import AssignCohortWithGroupsReducer from "./assign_cohort_with_groups_reducer";
import AssignOrientationReducer from "./assign_orientation_reducer";
import AttachUserToSiteReducer from "./attach_user_to_site_reducer";
import CancelAssignmentReducer from "./cancel_assignment_reducer";
import CancelCohortAssignmentReducer from "./cancel_cohort_assignment_reducer";
import CancelGroupRunReducer from "./cancel_group_run_reducer";
import ClientHelloReducer from "./client_hello_reducer";
import ClientLeftSessionReducer from "./client_left_session_reducer";
import CompleteAssignmentReducer from "./complete_assignment_reducer";
import CopyOrientationStepReducer from "./copy_orientation_step_reducer";
import CreateCohortReducer from "./create_cohort_reducer";
import CreateGroupRunReducer from "./create_group_run_reducer";
import CreateOrientationReducer from "./create_orientation_reducer";
import CreateOrientationStepReducer from "./create_orientation_step_reducer";
import DeleteAssignmentReducer from "./delete_assignment_reducer";
import DeleteOrientationReducer from "./delete_orientation_reducer";
import DeleteOrientationStepReducer from "./delete_orientation_step_reducer";
import DeleteOrientationStepScriptReducer from "./delete_orientation_step_script_reducer";
import DeleteUserReducer from "./delete_user_reducer";
import DetachUserFromSiteReducer from "./detach_user_from_site_reducer";
import DismissMyNotificationsReducer from "./dismiss_my_notifications_reducer";
import DismissNotificationReducer from "./dismiss_notification_reducer";
import DuplicateOrientationReducer from "./duplicate_orientation_reducer";
import EnsureMySessionParticipationReducer from "./ensure_my_session_participation_reducer";
import ExportOrientationsReducer from "./export_orientations_reducer";
import ImportOrientationsReducer from "./import_orientations_reducer";
import JoinSessionAsObserverReducer from "./join_session_as_observer_reducer";
import MarkMyNotificationsReadReducer from "./mark_my_notifications_read_reducer";
import PauseGroupRunReducer from "./pause_group_run_reducer";
import ReconcileAutoAssignmentsReducer from "./reconcile_auto_assignments_reducer";
import RegisterAdminServiceReducer from "./register_admin_service_reducer";
import RegisterOrgAdminServiceReducer from "./register_org_admin_service_reducer";
import RemoveOrgModuleUserReducer from "./remove_org_module_user_reducer";
import RemoveProjectAgentReducer from "./remove_project_agent_reducer";
import RemoveProjectMembershipReducer from "./remove_project_membership_reducer";
import RemoveStepFromOrientationReducer from "./remove_step_from_orientation_reducer";
import RenameCohortReducer from "./rename_cohort_reducer";
import ReorderStepsReducer from "./reorder_steps_reducer";
import RepointProjectSessionsReducer from "./repoint_project_sessions_reducer";
import ReportArrivalReducer from "./report_arrival_reducer";
import ReportStepBeatReducer from "./report_step_beat_reducer";
import ResetMyAssignmentsReducer from "./reset_my_assignments_reducer";
import ResumeGroupRunReducer from "./resume_group_run_reducer";
import SendBackAssignmentReducer from "./send_back_assignment_reducer";
import SetCohortMembersReducer from "./set_cohort_members_reducer";
import SetGroupReadyReducer from "./set_group_ready_reducer";
import SetGroupRunMembersReducer from "./set_group_run_members_reducer";
import SetMpServiceConfigReducer from "./set_mp_service_config_reducer";
import SetOrgModuleUserRoleReducer from "./set_org_module_user_role_reducer";
import SetOrientationCheckSettingsReducer from "./set_orientation_check_settings_reducer";
import SetOrientationStatusReducer from "./set_orientation_status_reducer";
import SetOrientationStepScriptReducer from "./set_orientation_step_script_reducer";
import SetPendingOccupationReducer from "./set_pending_occupation_reducer";
import SetProjectAgentReducer from "./set_project_agent_reducer";
import SetProjectMembershipReducer from "./set_project_membership_reducer";
import SetScriptActionsReducer from "./set_script_actions_reducer";
import SetSharedProjectAgentReducer from "./set_shared_project_agent_reducer";
import SetSiteAuthoringReducer from "./set_site_authoring_reducer";
import SetStepChecksReducer from "./set_step_checks_reducer";
import SetStepPositionReducer from "./set_step_position_reducer";
import SetUserDisplayNameReducer from "./set_user_display_name_reducer";
import SetUserOccupationReducer from "./set_user_occupation_reducer";
import SetWorkosOrgIdReducer from "./set_workos_org_id_reducer";
import StartAssignmentReducer from "./start_assignment_reducer";
import StartGroupRunReducer from "./start_group_run_reducer";
import SubmitCheckAnswerReducer from "./submit_check_answer_reducer";
import TakeOverGroupRunReducer from "./take_over_group_run_reducer";
import TransferOrgAdminServiceReducer from "./transfer_org_admin_service_reducer";
import TransferWorkosOrgIdReducer from "./transfer_workos_org_id_reducer";
import UpdateGroupRunReducer from "./update_group_run_reducer";
import UpdateOrientationReducer from "./update_orientation_reducer";
import UpdateOrientationStepReducer from "./update_orientation_step_reducer";

// Import all procedure arg schemas

// Import all table schema definitions
import AdminSiteIdsRow from "./admin_site_ids_table";
import AgentAssignmentProgressRow from "./agent_assignment_progress_table";
import AgentAssignmentsRow from "./agent_assignments_table";
import AgentGroupRunParticipantsRow from "./agent_group_run_participants_table";
import AgentGroupRunsRow from "./agent_group_runs_table";
import AgentOrientationChecksRow from "./agent_orientation_checks_table";
import AgentOrientationStepLinksRow from "./agent_orientation_step_links_table";
import AgentOrientationStepScriptsRow from "./agent_orientation_step_scripts_table";
import AgentOrientationStepsRow from "./agent_orientation_steps_table";
import AgentOrientationsRow from "./agent_orientations_table";
import AgentScriptActionsRow from "./agent_script_actions_table";
import AgentSiteRightsRow from "./agent_site_rights_table";
import AgentUsersRow from "./agent_users_table";
import AssignableOrientationsRow from "./assignable_orientations_table";
import CohortAssignmentProgressRow from "./cohort_assignment_progress_table";
import CohortCheckAnswersRow from "./cohort_check_answers_table";
import CohortProgressRow from "./cohort_progress_table";
import CohortStepMetricsRow from "./cohort_step_metrics_table";
import ExportResultEventRow from "./export_result_event_table";
import GroupRunCheckAnswersRow from "./group_run_check_answers_table";
import LeaderCheckKeysRow from "./leader_check_keys_table";
import MyAssignmentAttemptsRow from "./my_assignment_attempts_table";
import MyAssignmentProgressRow from "./my_assignment_progress_table";
import MyAssignmentStepMetricsRow from "./my_assignment_step_metrics_table";
import MyAssignmentsRow from "./my_assignments_table";
import MyCheckAnswersRow from "./my_check_answers_table";
import MyCheckKeysRow from "./my_check_keys_table";
import MyGroupRunRow from "./my_group_run_table";
import MyGroupRunDetailsRow from "./my_group_run_details_table";
import MyGroupRunLeadersRow from "./my_group_run_leaders_table";
import MyGroupRunParticipantsRow from "./my_group_run_participants_table";
import MyNotificationsRow from "./my_notifications_table";
import MyOrientationChecksRow from "./my_orientation_checks_table";
import MySessionCheckAnswersRow from "./my_session_check_answers_table";
import MySessionProgressRow from "./my_session_progress_table";
import MySessionTraineesRow from "./my_session_trainees_table";
import MySiteRightsRow from "./my_site_rights_table";
import MyUserRow from "./my_user_table";
import MyUserSitesRow from "./my_user_sites_table";
import OrgModuleUserRow from "./org_module_user_table";
import VisibleCohortAssignmentsRow from "./visible_cohort_assignments_table";
import VisibleCohortMembersRow from "./visible_cohort_members_table";
import VisibleCohortsRow from "./visible_cohorts_table";
import VisibleGroupRunLeadersRow from "./visible_group_run_leaders_table";
import VisibleGroupRunParticipantsRow from "./visible_group_run_participants_table";
import VisibleGroupRunsRow from "./visible_group_runs_table";
import VisibleOrientationCheckKeysRow from "./visible_orientation_check_keys_table";
import VisibleOrientationChecksRow from "./visible_orientation_checks_table";
import VisibleOrientationStepLinksRow from "./visible_orientation_step_links_table";
import VisibleOrientationStepScriptsRow from "./visible_orientation_step_scripts_table";
import VisibleOrientationStepsRow from "./visible_orientation_steps_table";
import VisibleOrientationsRow from "./visible_orientations_table";
import VisiblePendingUsersRow from "./visible_pending_users_table";
import VisibleProjectAgentsRow from "./visible_project_agents_table";
import VisibleScriptActionsRow from "./visible_script_actions_table";
import VisibleSiteRightsRow from "./visible_site_rights_table";
import VisibleUserSitesRow from "./visible_user_sites_table";
import VisibleUsersRow from "./visible_users_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  exportResultEvent: __table({
    name: 'export_result_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, ExportResultEventRow),
  orgModuleUser: __table({
    name: 'org_module_user',
    indexes: [
      { accessor: 'identity', name: 'org_module_user_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'org_module_user_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, OrgModuleUserRow),
  adminSiteIds: __table({
    name: 'admin_site_ids',
    indexes: [
    ],
    constraints: [
    ],
  }, AdminSiteIdsRow),
  agentAssignmentProgress: __table({
    name: 'agent_assignment_progress',
    indexes: [
    ],
    constraints: [
    ],
  }, AgentAssignmentProgressRow),
  agentAssignments: __table({
    name: 'agent_assignments',
    indexes: [
    ],
    constraints: [
    ],
  }, AgentAssignmentsRow),
  agentGroupRunParticipants: __table({
    name: 'agent_group_run_participants',
    indexes: [
    ],
    constraints: [
    ],
  }, AgentGroupRunParticipantsRow),
  agentGroupRuns: __table({
    name: 'agent_group_runs',
    indexes: [
    ],
    constraints: [
    ],
  }, AgentGroupRunsRow),
  agentOrientationChecks: __table({
    name: 'agent_orientation_checks',
    indexes: [
    ],
    constraints: [
    ],
  }, AgentOrientationChecksRow),
  agentOrientationStepLinks: __table({
    name: 'agent_orientation_step_links',
    indexes: [
    ],
    constraints: [
    ],
  }, AgentOrientationStepLinksRow),
  agentOrientationStepScripts: __table({
    name: 'agent_orientation_step_scripts',
    indexes: [
    ],
    constraints: [
    ],
  }, AgentOrientationStepScriptsRow),
  agentOrientationSteps: __table({
    name: 'agent_orientation_steps',
    indexes: [
    ],
    constraints: [
    ],
  }, AgentOrientationStepsRow),
  agentOrientations: __table({
    name: 'agent_orientations',
    indexes: [
    ],
    constraints: [
    ],
  }, AgentOrientationsRow),
  agentScriptActions: __table({
    name: 'agent_script_actions',
    indexes: [
    ],
    constraints: [
    ],
  }, AgentScriptActionsRow),
  agentSiteRights: __table({
    name: 'agent_site_rights',
    indexes: [
    ],
    constraints: [
    ],
  }, AgentSiteRightsRow),
  agentUsers: __table({
    name: 'agent_users',
    indexes: [
    ],
    constraints: [
    ],
  }, AgentUsersRow),
  assignableOrientations: __table({
    name: 'assignable_orientations',
    indexes: [
    ],
    constraints: [
    ],
  }, AssignableOrientationsRow),
  cohortAssignmentProgress: __table({
    name: 'cohort_assignment_progress',
    indexes: [
    ],
    constraints: [
    ],
  }, CohortAssignmentProgressRow),
  cohortCheckAnswers: __table({
    name: 'cohort_check_answers',
    indexes: [
    ],
    constraints: [
    ],
  }, CohortCheckAnswersRow),
  cohortProgress: __table({
    name: 'cohort_progress',
    indexes: [
    ],
    constraints: [
    ],
  }, CohortProgressRow),
  cohortStepMetrics: __table({
    name: 'cohort_step_metrics',
    indexes: [
    ],
    constraints: [
    ],
  }, CohortStepMetricsRow),
  groupRunCheckAnswers: __table({
    name: 'group_run_check_answers',
    indexes: [
    ],
    constraints: [
    ],
  }, GroupRunCheckAnswersRow),
  leaderCheckKeys: __table({
    name: 'leader_check_keys',
    indexes: [
    ],
    constraints: [
    ],
  }, LeaderCheckKeysRow),
  myAssignmentAttempts: __table({
    name: 'my_assignment_attempts',
    indexes: [
    ],
    constraints: [
    ],
  }, MyAssignmentAttemptsRow),
  myAssignmentProgress: __table({
    name: 'my_assignment_progress',
    indexes: [
    ],
    constraints: [
    ],
  }, MyAssignmentProgressRow),
  myAssignmentStepMetrics: __table({
    name: 'my_assignment_step_metrics',
    indexes: [
    ],
    constraints: [
    ],
  }, MyAssignmentStepMetricsRow),
  myAssignments: __table({
    name: 'my_assignments',
    indexes: [
    ],
    constraints: [
    ],
  }, MyAssignmentsRow),
  myCheckAnswers: __table({
    name: 'my_check_answers',
    indexes: [
    ],
    constraints: [
    ],
  }, MyCheckAnswersRow),
  myCheckKeys: __table({
    name: 'my_check_keys',
    indexes: [
    ],
    constraints: [
    ],
  }, MyCheckKeysRow),
  myGroupRun: __table({
    name: 'my_group_run',
    indexes: [
    ],
    constraints: [
    ],
  }, MyGroupRunRow),
  myGroupRunDetails: __table({
    name: 'my_group_run_details',
    indexes: [
    ],
    constraints: [
    ],
  }, MyGroupRunDetailsRow),
  myGroupRunLeaders: __table({
    name: 'my_group_run_leaders',
    indexes: [
    ],
    constraints: [
    ],
  }, MyGroupRunLeadersRow),
  myGroupRunParticipants: __table({
    name: 'my_group_run_participants',
    indexes: [
    ],
    constraints: [
    ],
  }, MyGroupRunParticipantsRow),
  myNotifications: __table({
    name: 'my_notifications',
    indexes: [
    ],
    constraints: [
    ],
  }, MyNotificationsRow),
  myOrientationChecks: __table({
    name: 'my_orientation_checks',
    indexes: [
    ],
    constraints: [
    ],
  }, MyOrientationChecksRow),
  mySessionCheckAnswers: __table({
    name: 'my_session_check_answers',
    indexes: [
    ],
    constraints: [
    ],
  }, MySessionCheckAnswersRow),
  mySessionProgress: __table({
    name: 'my_session_progress',
    indexes: [
    ],
    constraints: [
    ],
  }, MySessionProgressRow),
  mySessionTrainees: __table({
    name: 'my_session_trainees',
    indexes: [
    ],
    constraints: [
    ],
  }, MySessionTraineesRow),
  mySiteRights: __table({
    name: 'my_site_rights',
    indexes: [
    ],
    constraints: [
    ],
  }, MySiteRightsRow),
  myUser: __table({
    name: 'my_user',
    indexes: [
    ],
    constraints: [
    ],
  }, MyUserRow),
  myUserSites: __table({
    name: 'my_user_sites',
    indexes: [
    ],
    constraints: [
    ],
  }, MyUserSitesRow),
  visibleCohortAssignments: __table({
    name: 'visible_cohort_assignments',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleCohortAssignmentsRow),
  visibleCohortMembers: __table({
    name: 'visible_cohort_members',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleCohortMembersRow),
  visibleCohorts: __table({
    name: 'visible_cohorts',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleCohortsRow),
  visibleGroupRunLeaders: __table({
    name: 'visible_group_run_leaders',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleGroupRunLeadersRow),
  visibleGroupRunParticipants: __table({
    name: 'visible_group_run_participants',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleGroupRunParticipantsRow),
  visibleGroupRuns: __table({
    name: 'visible_group_runs',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleGroupRunsRow),
  visibleOrientationCheckKeys: __table({
    name: 'visible_orientation_check_keys',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleOrientationCheckKeysRow),
  visibleOrientationChecks: __table({
    name: 'visible_orientation_checks',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleOrientationChecksRow),
  visibleOrientationStepLinks: __table({
    name: 'visible_orientation_step_links',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleOrientationStepLinksRow),
  visibleOrientationStepScripts: __table({
    name: 'visible_orientation_step_scripts',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleOrientationStepScriptsRow),
  visibleOrientationSteps: __table({
    name: 'visible_orientation_steps',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleOrientationStepsRow),
  visibleOrientations: __table({
    name: 'visible_orientations',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleOrientationsRow),
  visiblePendingUsers: __table({
    name: 'visible_pending_users',
    indexes: [
    ],
    constraints: [
    ],
  }, VisiblePendingUsersRow),
  visibleProjectAgents: __table({
    name: 'visible_project_agents',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleProjectAgentsRow),
  visibleScriptActions: __table({
    name: 'visible_script_actions',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleScriptActionsRow),
  visibleSiteRights: __table({
    name: 'visible_site_rights',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleSiteRightsRow),
  visibleUserSites: __table({
    name: 'visible_user_sites',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleUserSitesRow),
  visibleUsers: __table({
    name: 'visible_users',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleUsersRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("add_step_to_orientation", AddStepToOrientationReducer),
  __reducerSchema("add_user", AddUserReducer),
  __reducerSchema("advance_assignment", AdvanceAssignmentReducer),
  __reducerSchema("advance_group_run", AdvanceGroupRunReducer),
  __reducerSchema("archive_cohort", ArchiveCohortReducer),
  __reducerSchema("archive_cohort_finish_live", ArchiveCohortFinishLiveReducer),
  __reducerSchema("archive_user", ArchiveUserReducer),
  __reducerSchema("assign_cohort", AssignCohortReducer),
  __reducerSchema("assign_cohort_with_groups", AssignCohortWithGroupsReducer),
  __reducerSchema("assign_orientation", AssignOrientationReducer),
  __reducerSchema("attach_user_to_site", AttachUserToSiteReducer),
  __reducerSchema("cancel_assignment", CancelAssignmentReducer),
  __reducerSchema("cancel_cohort_assignment", CancelCohortAssignmentReducer),
  __reducerSchema("cancel_group_run", CancelGroupRunReducer),
  __reducerSchema("client_hello", ClientHelloReducer),
  __reducerSchema("client_left_session", ClientLeftSessionReducer),
  __reducerSchema("complete_assignment", CompleteAssignmentReducer),
  __reducerSchema("copy_orientation_step", CopyOrientationStepReducer),
  __reducerSchema("create_cohort", CreateCohortReducer),
  __reducerSchema("create_group_run", CreateGroupRunReducer),
  __reducerSchema("create_orientation", CreateOrientationReducer),
  __reducerSchema("create_orientation_step", CreateOrientationStepReducer),
  __reducerSchema("delete_assignment", DeleteAssignmentReducer),
  __reducerSchema("delete_orientation", DeleteOrientationReducer),
  __reducerSchema("delete_orientation_step", DeleteOrientationStepReducer),
  __reducerSchema("delete_orientation_step_script", DeleteOrientationStepScriptReducer),
  __reducerSchema("delete_user", DeleteUserReducer),
  __reducerSchema("detach_user_from_site", DetachUserFromSiteReducer),
  __reducerSchema("dismiss_my_notifications", DismissMyNotificationsReducer),
  __reducerSchema("dismiss_notification", DismissNotificationReducer),
  __reducerSchema("duplicate_orientation", DuplicateOrientationReducer),
  __reducerSchema("ensure_my_session_participation", EnsureMySessionParticipationReducer),
  __reducerSchema("export_orientations", ExportOrientationsReducer),
  __reducerSchema("import_orientations", ImportOrientationsReducer),
  __reducerSchema("join_session_as_observer", JoinSessionAsObserverReducer),
  __reducerSchema("mark_my_notifications_read", MarkMyNotificationsReadReducer),
  __reducerSchema("pause_group_run", PauseGroupRunReducer),
  __reducerSchema("reconcile_auto_assignments", ReconcileAutoAssignmentsReducer),
  __reducerSchema("register_admin_service", RegisterAdminServiceReducer),
  __reducerSchema("register_org_admin_service", RegisterOrgAdminServiceReducer),
  __reducerSchema("remove_org_module_user", RemoveOrgModuleUserReducer),
  __reducerSchema("remove_project_agent", RemoveProjectAgentReducer),
  __reducerSchema("remove_project_membership", RemoveProjectMembershipReducer),
  __reducerSchema("remove_step_from_orientation", RemoveStepFromOrientationReducer),
  __reducerSchema("rename_cohort", RenameCohortReducer),
  __reducerSchema("reorder_steps", ReorderStepsReducer),
  __reducerSchema("repoint_project_sessions", RepointProjectSessionsReducer),
  __reducerSchema("report_arrival", ReportArrivalReducer),
  __reducerSchema("report_step_beat", ReportStepBeatReducer),
  __reducerSchema("reset_my_assignments", ResetMyAssignmentsReducer),
  __reducerSchema("resume_group_run", ResumeGroupRunReducer),
  __reducerSchema("send_back_assignment", SendBackAssignmentReducer),
  __reducerSchema("set_cohort_members", SetCohortMembersReducer),
  __reducerSchema("set_group_ready", SetGroupReadyReducer),
  __reducerSchema("set_group_run_members", SetGroupRunMembersReducer),
  __reducerSchema("set_mp_service_config", SetMpServiceConfigReducer),
  __reducerSchema("set_org_module_user_role", SetOrgModuleUserRoleReducer),
  __reducerSchema("set_orientation_check_settings", SetOrientationCheckSettingsReducer),
  __reducerSchema("set_orientation_status", SetOrientationStatusReducer),
  __reducerSchema("set_orientation_step_script", SetOrientationStepScriptReducer),
  __reducerSchema("set_pending_occupation", SetPendingOccupationReducer),
  __reducerSchema("set_project_agent", SetProjectAgentReducer),
  __reducerSchema("set_project_membership", SetProjectMembershipReducer),
  __reducerSchema("set_script_actions", SetScriptActionsReducer),
  __reducerSchema("set_shared_project_agent", SetSharedProjectAgentReducer),
  __reducerSchema("set_site_authoring", SetSiteAuthoringReducer),
  __reducerSchema("set_step_checks", SetStepChecksReducer),
  __reducerSchema("set_step_position", SetStepPositionReducer),
  __reducerSchema("set_user_display_name", SetUserDisplayNameReducer),
  __reducerSchema("set_user_occupation", SetUserOccupationReducer),
  __reducerSchema("set_workos_org_id", SetWorkosOrgIdReducer),
  __reducerSchema("start_assignment", StartAssignmentReducer),
  __reducerSchema("start_group_run", StartGroupRunReducer),
  __reducerSchema("submit_check_answer", SubmitCheckAnswerReducer),
  __reducerSchema("take_over_group_run", TakeOverGroupRunReducer),
  __reducerSchema("transfer_org_admin_service", TransferOrgAdminServiceReducer),
  __reducerSchema("transfer_workos_org_id", TransferWorkosOrgIdReducer),
  __reducerSchema("update_group_run", UpdateGroupRunReducer),
  __reducerSchema("update_orientation", UpdateOrientationReducer),
  __reducerSchema("update_orientation_step", UpdateOrientationStepReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

type __SchemaWithTableAccessorAliases = Omit<typeof tablesSchema.schemaType, "tables"> & {
  tables: typeof tablesSchema.schemaType.tables & {
    /** @deprecated Use `exportResultEvent` instead. This alias will be removed in the next major version. */
    readonly "export_result_event": Omit<typeof tablesSchema.schemaType.tables["exportResultEvent"], "accessorName"> & { readonly accessorName: "export_result_event" };
    /** @deprecated Use `orgModuleUser` instead. This alias will be removed in the next major version. */
    readonly "org_module_user": Omit<typeof tablesSchema.schemaType.tables["orgModuleUser"], "accessorName"> & { readonly accessorName: "org_module_user" };
    /** @deprecated Use `adminSiteIds` instead. This alias will be removed in the next major version. */
    readonly "admin_site_ids": Omit<typeof tablesSchema.schemaType.tables["adminSiteIds"], "accessorName"> & { readonly accessorName: "admin_site_ids" };
    /** @deprecated Use `agentAssignmentProgress` instead. This alias will be removed in the next major version. */
    readonly "agent_assignment_progress": Omit<typeof tablesSchema.schemaType.tables["agentAssignmentProgress"], "accessorName"> & { readonly accessorName: "agent_assignment_progress" };
    /** @deprecated Use `agentAssignments` instead. This alias will be removed in the next major version. */
    readonly "agent_assignments": Omit<typeof tablesSchema.schemaType.tables["agentAssignments"], "accessorName"> & { readonly accessorName: "agent_assignments" };
    /** @deprecated Use `agentGroupRunParticipants` instead. This alias will be removed in the next major version. */
    readonly "agent_group_run_participants": Omit<typeof tablesSchema.schemaType.tables["agentGroupRunParticipants"], "accessorName"> & { readonly accessorName: "agent_group_run_participants" };
    /** @deprecated Use `agentGroupRuns` instead. This alias will be removed in the next major version. */
    readonly "agent_group_runs": Omit<typeof tablesSchema.schemaType.tables["agentGroupRuns"], "accessorName"> & { readonly accessorName: "agent_group_runs" };
    /** @deprecated Use `agentOrientationChecks` instead. This alias will be removed in the next major version. */
    readonly "agent_orientation_checks": Omit<typeof tablesSchema.schemaType.tables["agentOrientationChecks"], "accessorName"> & { readonly accessorName: "agent_orientation_checks" };
    /** @deprecated Use `agentOrientationStepLinks` instead. This alias will be removed in the next major version. */
    readonly "agent_orientation_step_links": Omit<typeof tablesSchema.schemaType.tables["agentOrientationStepLinks"], "accessorName"> & { readonly accessorName: "agent_orientation_step_links" };
    /** @deprecated Use `agentOrientationStepScripts` instead. This alias will be removed in the next major version. */
    readonly "agent_orientation_step_scripts": Omit<typeof tablesSchema.schemaType.tables["agentOrientationStepScripts"], "accessorName"> & { readonly accessorName: "agent_orientation_step_scripts" };
    /** @deprecated Use `agentOrientationSteps` instead. This alias will be removed in the next major version. */
    readonly "agent_orientation_steps": Omit<typeof tablesSchema.schemaType.tables["agentOrientationSteps"], "accessorName"> & { readonly accessorName: "agent_orientation_steps" };
    /** @deprecated Use `agentOrientations` instead. This alias will be removed in the next major version. */
    readonly "agent_orientations": Omit<typeof tablesSchema.schemaType.tables["agentOrientations"], "accessorName"> & { readonly accessorName: "agent_orientations" };
    /** @deprecated Use `agentScriptActions` instead. This alias will be removed in the next major version. */
    readonly "agent_script_actions": Omit<typeof tablesSchema.schemaType.tables["agentScriptActions"], "accessorName"> & { readonly accessorName: "agent_script_actions" };
    /** @deprecated Use `agentSiteRights` instead. This alias will be removed in the next major version. */
    readonly "agent_site_rights": Omit<typeof tablesSchema.schemaType.tables["agentSiteRights"], "accessorName"> & { readonly accessorName: "agent_site_rights" };
    /** @deprecated Use `agentUsers` instead. This alias will be removed in the next major version. */
    readonly "agent_users": Omit<typeof tablesSchema.schemaType.tables["agentUsers"], "accessorName"> & { readonly accessorName: "agent_users" };
    /** @deprecated Use `assignableOrientations` instead. This alias will be removed in the next major version. */
    readonly "assignable_orientations": Omit<typeof tablesSchema.schemaType.tables["assignableOrientations"], "accessorName"> & { readonly accessorName: "assignable_orientations" };
    /** @deprecated Use `cohortAssignmentProgress` instead. This alias will be removed in the next major version. */
    readonly "cohort_assignment_progress": Omit<typeof tablesSchema.schemaType.tables["cohortAssignmentProgress"], "accessorName"> & { readonly accessorName: "cohort_assignment_progress" };
    /** @deprecated Use `cohortCheckAnswers` instead. This alias will be removed in the next major version. */
    readonly "cohort_check_answers": Omit<typeof tablesSchema.schemaType.tables["cohortCheckAnswers"], "accessorName"> & { readonly accessorName: "cohort_check_answers" };
    /** @deprecated Use `cohortProgress` instead. This alias will be removed in the next major version. */
    readonly "cohort_progress": Omit<typeof tablesSchema.schemaType.tables["cohortProgress"], "accessorName"> & { readonly accessorName: "cohort_progress" };
    /** @deprecated Use `cohortStepMetrics` instead. This alias will be removed in the next major version. */
    readonly "cohort_step_metrics": Omit<typeof tablesSchema.schemaType.tables["cohortStepMetrics"], "accessorName"> & { readonly accessorName: "cohort_step_metrics" };
    /** @deprecated Use `groupRunCheckAnswers` instead. This alias will be removed in the next major version. */
    readonly "group_run_check_answers": Omit<typeof tablesSchema.schemaType.tables["groupRunCheckAnswers"], "accessorName"> & { readonly accessorName: "group_run_check_answers" };
    /** @deprecated Use `leaderCheckKeys` instead. This alias will be removed in the next major version. */
    readonly "leader_check_keys": Omit<typeof tablesSchema.schemaType.tables["leaderCheckKeys"], "accessorName"> & { readonly accessorName: "leader_check_keys" };
    /** @deprecated Use `myAssignmentAttempts` instead. This alias will be removed in the next major version. */
    readonly "my_assignment_attempts": Omit<typeof tablesSchema.schemaType.tables["myAssignmentAttempts"], "accessorName"> & { readonly accessorName: "my_assignment_attempts" };
    /** @deprecated Use `myAssignmentProgress` instead. This alias will be removed in the next major version. */
    readonly "my_assignment_progress": Omit<typeof tablesSchema.schemaType.tables["myAssignmentProgress"], "accessorName"> & { readonly accessorName: "my_assignment_progress" };
    /** @deprecated Use `myAssignmentStepMetrics` instead. This alias will be removed in the next major version. */
    readonly "my_assignment_step_metrics": Omit<typeof tablesSchema.schemaType.tables["myAssignmentStepMetrics"], "accessorName"> & { readonly accessorName: "my_assignment_step_metrics" };
    /** @deprecated Use `myAssignments` instead. This alias will be removed in the next major version. */
    readonly "my_assignments": Omit<typeof tablesSchema.schemaType.tables["myAssignments"], "accessorName"> & { readonly accessorName: "my_assignments" };
    /** @deprecated Use `myCheckAnswers` instead. This alias will be removed in the next major version. */
    readonly "my_check_answers": Omit<typeof tablesSchema.schemaType.tables["myCheckAnswers"], "accessorName"> & { readonly accessorName: "my_check_answers" };
    /** @deprecated Use `myCheckKeys` instead. This alias will be removed in the next major version. */
    readonly "my_check_keys": Omit<typeof tablesSchema.schemaType.tables["myCheckKeys"], "accessorName"> & { readonly accessorName: "my_check_keys" };
    /** @deprecated Use `myGroupRun` instead. This alias will be removed in the next major version. */
    readonly "my_group_run": Omit<typeof tablesSchema.schemaType.tables["myGroupRun"], "accessorName"> & { readonly accessorName: "my_group_run" };
    /** @deprecated Use `myGroupRunDetails` instead. This alias will be removed in the next major version. */
    readonly "my_group_run_details": Omit<typeof tablesSchema.schemaType.tables["myGroupRunDetails"], "accessorName"> & { readonly accessorName: "my_group_run_details" };
    /** @deprecated Use `myGroupRunLeaders` instead. This alias will be removed in the next major version. */
    readonly "my_group_run_leaders": Omit<typeof tablesSchema.schemaType.tables["myGroupRunLeaders"], "accessorName"> & { readonly accessorName: "my_group_run_leaders" };
    /** @deprecated Use `myGroupRunParticipants` instead. This alias will be removed in the next major version. */
    readonly "my_group_run_participants": Omit<typeof tablesSchema.schemaType.tables["myGroupRunParticipants"], "accessorName"> & { readonly accessorName: "my_group_run_participants" };
    /** @deprecated Use `myNotifications` instead. This alias will be removed in the next major version. */
    readonly "my_notifications": Omit<typeof tablesSchema.schemaType.tables["myNotifications"], "accessorName"> & { readonly accessorName: "my_notifications" };
    /** @deprecated Use `myOrientationChecks` instead. This alias will be removed in the next major version. */
    readonly "my_orientation_checks": Omit<typeof tablesSchema.schemaType.tables["myOrientationChecks"], "accessorName"> & { readonly accessorName: "my_orientation_checks" };
    /** @deprecated Use `mySessionCheckAnswers` instead. This alias will be removed in the next major version. */
    readonly "my_session_check_answers": Omit<typeof tablesSchema.schemaType.tables["mySessionCheckAnswers"], "accessorName"> & { readonly accessorName: "my_session_check_answers" };
    /** @deprecated Use `mySessionProgress` instead. This alias will be removed in the next major version. */
    readonly "my_session_progress": Omit<typeof tablesSchema.schemaType.tables["mySessionProgress"], "accessorName"> & { readonly accessorName: "my_session_progress" };
    /** @deprecated Use `mySessionTrainees` instead. This alias will be removed in the next major version. */
    readonly "my_session_trainees": Omit<typeof tablesSchema.schemaType.tables["mySessionTrainees"], "accessorName"> & { readonly accessorName: "my_session_trainees" };
    /** @deprecated Use `mySiteRights` instead. This alias will be removed in the next major version. */
    readonly "my_site_rights": Omit<typeof tablesSchema.schemaType.tables["mySiteRights"], "accessorName"> & { readonly accessorName: "my_site_rights" };
    /** @deprecated Use `myUser` instead. This alias will be removed in the next major version. */
    readonly "my_user": Omit<typeof tablesSchema.schemaType.tables["myUser"], "accessorName"> & { readonly accessorName: "my_user" };
    /** @deprecated Use `myUserSites` instead. This alias will be removed in the next major version. */
    readonly "my_user_sites": Omit<typeof tablesSchema.schemaType.tables["myUserSites"], "accessorName"> & { readonly accessorName: "my_user_sites" };
    /** @deprecated Use `visibleCohortAssignments` instead. This alias will be removed in the next major version. */
    readonly "visible_cohort_assignments": Omit<typeof tablesSchema.schemaType.tables["visibleCohortAssignments"], "accessorName"> & { readonly accessorName: "visible_cohort_assignments" };
    /** @deprecated Use `visibleCohortMembers` instead. This alias will be removed in the next major version. */
    readonly "visible_cohort_members": Omit<typeof tablesSchema.schemaType.tables["visibleCohortMembers"], "accessorName"> & { readonly accessorName: "visible_cohort_members" };
    /** @deprecated Use `visibleCohorts` instead. This alias will be removed in the next major version. */
    readonly "visible_cohorts": Omit<typeof tablesSchema.schemaType.tables["visibleCohorts"], "accessorName"> & { readonly accessorName: "visible_cohorts" };
    /** @deprecated Use `visibleGroupRunLeaders` instead. This alias will be removed in the next major version. */
    readonly "visible_group_run_leaders": Omit<typeof tablesSchema.schemaType.tables["visibleGroupRunLeaders"], "accessorName"> & { readonly accessorName: "visible_group_run_leaders" };
    /** @deprecated Use `visibleGroupRunParticipants` instead. This alias will be removed in the next major version. */
    readonly "visible_group_run_participants": Omit<typeof tablesSchema.schemaType.tables["visibleGroupRunParticipants"], "accessorName"> & { readonly accessorName: "visible_group_run_participants" };
    /** @deprecated Use `visibleGroupRuns` instead. This alias will be removed in the next major version. */
    readonly "visible_group_runs": Omit<typeof tablesSchema.schemaType.tables["visibleGroupRuns"], "accessorName"> & { readonly accessorName: "visible_group_runs" };
    /** @deprecated Use `visibleOrientationCheckKeys` instead. This alias will be removed in the next major version. */
    readonly "visible_orientation_check_keys": Omit<typeof tablesSchema.schemaType.tables["visibleOrientationCheckKeys"], "accessorName"> & { readonly accessorName: "visible_orientation_check_keys" };
    /** @deprecated Use `visibleOrientationChecks` instead. This alias will be removed in the next major version. */
    readonly "visible_orientation_checks": Omit<typeof tablesSchema.schemaType.tables["visibleOrientationChecks"], "accessorName"> & { readonly accessorName: "visible_orientation_checks" };
    /** @deprecated Use `visibleOrientationStepLinks` instead. This alias will be removed in the next major version. */
    readonly "visible_orientation_step_links": Omit<typeof tablesSchema.schemaType.tables["visibleOrientationStepLinks"], "accessorName"> & { readonly accessorName: "visible_orientation_step_links" };
    /** @deprecated Use `visibleOrientationStepScripts` instead. This alias will be removed in the next major version. */
    readonly "visible_orientation_step_scripts": Omit<typeof tablesSchema.schemaType.tables["visibleOrientationStepScripts"], "accessorName"> & { readonly accessorName: "visible_orientation_step_scripts" };
    /** @deprecated Use `visibleOrientationSteps` instead. This alias will be removed in the next major version. */
    readonly "visible_orientation_steps": Omit<typeof tablesSchema.schemaType.tables["visibleOrientationSteps"], "accessorName"> & { readonly accessorName: "visible_orientation_steps" };
    /** @deprecated Use `visibleOrientations` instead. This alias will be removed in the next major version. */
    readonly "visible_orientations": Omit<typeof tablesSchema.schemaType.tables["visibleOrientations"], "accessorName"> & { readonly accessorName: "visible_orientations" };
    /** @deprecated Use `visiblePendingUsers` instead. This alias will be removed in the next major version. */
    readonly "visible_pending_users": Omit<typeof tablesSchema.schemaType.tables["visiblePendingUsers"], "accessorName"> & { readonly accessorName: "visible_pending_users" };
    /** @deprecated Use `visibleProjectAgents` instead. This alias will be removed in the next major version. */
    readonly "visible_project_agents": Omit<typeof tablesSchema.schemaType.tables["visibleProjectAgents"], "accessorName"> & { readonly accessorName: "visible_project_agents" };
    /** @deprecated Use `visibleScriptActions` instead. This alias will be removed in the next major version. */
    readonly "visible_script_actions": Omit<typeof tablesSchema.schemaType.tables["visibleScriptActions"], "accessorName"> & { readonly accessorName: "visible_script_actions" };
    /** @deprecated Use `visibleSiteRights` instead. This alias will be removed in the next major version. */
    readonly "visible_site_rights": Omit<typeof tablesSchema.schemaType.tables["visibleSiteRights"], "accessorName"> & { readonly accessorName: "visible_site_rights" };
    /** @deprecated Use `visibleUserSites` instead. This alias will be removed in the next major version. */
    readonly "visible_user_sites": Omit<typeof tablesSchema.schemaType.tables["visibleUserSites"], "accessorName"> & { readonly accessorName: "visible_user_sites" };
    /** @deprecated Use `visibleUsers` instead. This alias will be removed in the next major version. */
    readonly "visible_users": Omit<typeof tablesSchema.schemaType.tables["visibleUsers"], "accessorName"> & { readonly accessorName: "visible_users" };
  };
};

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.13.0" as const,
  },
  tables: tablesSchema.schemaType.tables as __SchemaWithTableAccessorAliases["tables"],
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  __SchemaWithTableAccessorAliases,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

const tableAccessorAliases = {
  "export_result_event": "exportResultEvent",
  "org_module_user": "orgModuleUser",
  "admin_site_ids": "adminSiteIds",
  "agent_assignment_progress": "agentAssignmentProgress",
  "agent_assignments": "agentAssignments",
  "agent_group_run_participants": "agentGroupRunParticipants",
  "agent_group_runs": "agentGroupRuns",
  "agent_orientation_checks": "agentOrientationChecks",
  "agent_orientation_step_links": "agentOrientationStepLinks",
  "agent_orientation_step_scripts": "agentOrientationStepScripts",
  "agent_orientation_steps": "agentOrientationSteps",
  "agent_orientations": "agentOrientations",
  "agent_script_actions": "agentScriptActions",
  "agent_site_rights": "agentSiteRights",
  "agent_users": "agentUsers",
  "assignable_orientations": "assignableOrientations",
  "cohort_assignment_progress": "cohortAssignmentProgress",
  "cohort_check_answers": "cohortCheckAnswers",
  "cohort_progress": "cohortProgress",
  "cohort_step_metrics": "cohortStepMetrics",
  "group_run_check_answers": "groupRunCheckAnswers",
  "leader_check_keys": "leaderCheckKeys",
  "my_assignment_attempts": "myAssignmentAttempts",
  "my_assignment_progress": "myAssignmentProgress",
  "my_assignment_step_metrics": "myAssignmentStepMetrics",
  "my_assignments": "myAssignments",
  "my_check_answers": "myCheckAnswers",
  "my_check_keys": "myCheckKeys",
  "my_group_run": "myGroupRun",
  "my_group_run_details": "myGroupRunDetails",
  "my_group_run_leaders": "myGroupRunLeaders",
  "my_group_run_participants": "myGroupRunParticipants",
  "my_notifications": "myNotifications",
  "my_orientation_checks": "myOrientationChecks",
  "my_session_check_answers": "mySessionCheckAnswers",
  "my_session_progress": "mySessionProgress",
  "my_session_trainees": "mySessionTrainees",
  "my_site_rights": "mySiteRights",
  "my_user": "myUser",
  "my_user_sites": "myUserSites",
  "visible_cohort_assignments": "visibleCohortAssignments",
  "visible_cohort_members": "visibleCohortMembers",
  "visible_cohorts": "visibleCohorts",
  "visible_group_run_leaders": "visibleGroupRunLeaders",
  "visible_group_run_participants": "visibleGroupRunParticipants",
  "visible_group_runs": "visibleGroupRuns",
  "visible_orientation_check_keys": "visibleOrientationCheckKeys",
  "visible_orientation_checks": "visibleOrientationChecks",
  "visible_orientation_step_links": "visibleOrientationStepLinks",
  "visible_orientation_step_scripts": "visibleOrientationStepScripts",
  "visible_orientation_steps": "visibleOrientationSteps",
  "visible_orientations": "visibleOrientations",
  "visible_pending_users": "visiblePendingUsers",
  "visible_project_agents": "visibleProjectAgents",
  "visible_script_actions": "visibleScriptActions",
  "visible_site_rights": "visibleSiteRights",
  "visible_user_sites": "visibleUserSites",
  "visible_users": "visibleUsers",
} as const;

function __withTableAccessorAliases<T extends object>(target: T, freeze = false): T {
  const out = Object.create(Object.getPrototypeOf(target)) as T & Record<string, unknown>;
  Object.defineProperties(out, Object.getOwnPropertyDescriptors(target));
  for (const [deprecatedAccessor, targetAccessor] of Object.entries(tableAccessorAliases)) {
    if (deprecatedAccessor in out) {
      continue;
    }
    Object.defineProperty(out, deprecatedAccessor, {
      enumerable: true,
      configurable: false,
      get: () => out[targetAccessor],
    });
  }
  return freeze ? Object.freeze(out) : out;
}

type __DbViewBase = __DbConnectionImpl<typeof REMOTE_MODULE>["db"];
export type DbView = __DbViewBase & {
  /** @deprecated Use `exportResultEvent` instead. This alias will be removed in the next major version. */
  readonly "export_result_event": __DbViewBase["exportResultEvent"];
  /** @deprecated Use `orgModuleUser` instead. This alias will be removed in the next major version. */
  readonly "org_module_user": __DbViewBase["orgModuleUser"];
  /** @deprecated Use `adminSiteIds` instead. This alias will be removed in the next major version. */
  readonly "admin_site_ids": __DbViewBase["adminSiteIds"];
  /** @deprecated Use `agentAssignmentProgress` instead. This alias will be removed in the next major version. */
  readonly "agent_assignment_progress": __DbViewBase["agentAssignmentProgress"];
  /** @deprecated Use `agentAssignments` instead. This alias will be removed in the next major version. */
  readonly "agent_assignments": __DbViewBase["agentAssignments"];
  /** @deprecated Use `agentGroupRunParticipants` instead. This alias will be removed in the next major version. */
  readonly "agent_group_run_participants": __DbViewBase["agentGroupRunParticipants"];
  /** @deprecated Use `agentGroupRuns` instead. This alias will be removed in the next major version. */
  readonly "agent_group_runs": __DbViewBase["agentGroupRuns"];
  /** @deprecated Use `agentOrientationChecks` instead. This alias will be removed in the next major version. */
  readonly "agent_orientation_checks": __DbViewBase["agentOrientationChecks"];
  /** @deprecated Use `agentOrientationStepLinks` instead. This alias will be removed in the next major version. */
  readonly "agent_orientation_step_links": __DbViewBase["agentOrientationStepLinks"];
  /** @deprecated Use `agentOrientationStepScripts` instead. This alias will be removed in the next major version. */
  readonly "agent_orientation_step_scripts": __DbViewBase["agentOrientationStepScripts"];
  /** @deprecated Use `agentOrientationSteps` instead. This alias will be removed in the next major version. */
  readonly "agent_orientation_steps": __DbViewBase["agentOrientationSteps"];
  /** @deprecated Use `agentOrientations` instead. This alias will be removed in the next major version. */
  readonly "agent_orientations": __DbViewBase["agentOrientations"];
  /** @deprecated Use `agentScriptActions` instead. This alias will be removed in the next major version. */
  readonly "agent_script_actions": __DbViewBase["agentScriptActions"];
  /** @deprecated Use `agentSiteRights` instead. This alias will be removed in the next major version. */
  readonly "agent_site_rights": __DbViewBase["agentSiteRights"];
  /** @deprecated Use `agentUsers` instead. This alias will be removed in the next major version. */
  readonly "agent_users": __DbViewBase["agentUsers"];
  /** @deprecated Use `assignableOrientations` instead. This alias will be removed in the next major version. */
  readonly "assignable_orientations": __DbViewBase["assignableOrientations"];
  /** @deprecated Use `cohortAssignmentProgress` instead. This alias will be removed in the next major version. */
  readonly "cohort_assignment_progress": __DbViewBase["cohortAssignmentProgress"];
  /** @deprecated Use `cohortCheckAnswers` instead. This alias will be removed in the next major version. */
  readonly "cohort_check_answers": __DbViewBase["cohortCheckAnswers"];
  /** @deprecated Use `cohortProgress` instead. This alias will be removed in the next major version. */
  readonly "cohort_progress": __DbViewBase["cohortProgress"];
  /** @deprecated Use `cohortStepMetrics` instead. This alias will be removed in the next major version. */
  readonly "cohort_step_metrics": __DbViewBase["cohortStepMetrics"];
  /** @deprecated Use `groupRunCheckAnswers` instead. This alias will be removed in the next major version. */
  readonly "group_run_check_answers": __DbViewBase["groupRunCheckAnswers"];
  /** @deprecated Use `leaderCheckKeys` instead. This alias will be removed in the next major version. */
  readonly "leader_check_keys": __DbViewBase["leaderCheckKeys"];
  /** @deprecated Use `myAssignmentAttempts` instead. This alias will be removed in the next major version. */
  readonly "my_assignment_attempts": __DbViewBase["myAssignmentAttempts"];
  /** @deprecated Use `myAssignmentProgress` instead. This alias will be removed in the next major version. */
  readonly "my_assignment_progress": __DbViewBase["myAssignmentProgress"];
  /** @deprecated Use `myAssignmentStepMetrics` instead. This alias will be removed in the next major version. */
  readonly "my_assignment_step_metrics": __DbViewBase["myAssignmentStepMetrics"];
  /** @deprecated Use `myAssignments` instead. This alias will be removed in the next major version. */
  readonly "my_assignments": __DbViewBase["myAssignments"];
  /** @deprecated Use `myCheckAnswers` instead. This alias will be removed in the next major version. */
  readonly "my_check_answers": __DbViewBase["myCheckAnswers"];
  /** @deprecated Use `myCheckKeys` instead. This alias will be removed in the next major version. */
  readonly "my_check_keys": __DbViewBase["myCheckKeys"];
  /** @deprecated Use `myGroupRun` instead. This alias will be removed in the next major version. */
  readonly "my_group_run": __DbViewBase["myGroupRun"];
  /** @deprecated Use `myGroupRunDetails` instead. This alias will be removed in the next major version. */
  readonly "my_group_run_details": __DbViewBase["myGroupRunDetails"];
  /** @deprecated Use `myGroupRunLeaders` instead. This alias will be removed in the next major version. */
  readonly "my_group_run_leaders": __DbViewBase["myGroupRunLeaders"];
  /** @deprecated Use `myGroupRunParticipants` instead. This alias will be removed in the next major version. */
  readonly "my_group_run_participants": __DbViewBase["myGroupRunParticipants"];
  /** @deprecated Use `myNotifications` instead. This alias will be removed in the next major version. */
  readonly "my_notifications": __DbViewBase["myNotifications"];
  /** @deprecated Use `myOrientationChecks` instead. This alias will be removed in the next major version. */
  readonly "my_orientation_checks": __DbViewBase["myOrientationChecks"];
  /** @deprecated Use `mySessionCheckAnswers` instead. This alias will be removed in the next major version. */
  readonly "my_session_check_answers": __DbViewBase["mySessionCheckAnswers"];
  /** @deprecated Use `mySessionProgress` instead. This alias will be removed in the next major version. */
  readonly "my_session_progress": __DbViewBase["mySessionProgress"];
  /** @deprecated Use `mySessionTrainees` instead. This alias will be removed in the next major version. */
  readonly "my_session_trainees": __DbViewBase["mySessionTrainees"];
  /** @deprecated Use `mySiteRights` instead. This alias will be removed in the next major version. */
  readonly "my_site_rights": __DbViewBase["mySiteRights"];
  /** @deprecated Use `myUser` instead. This alias will be removed in the next major version. */
  readonly "my_user": __DbViewBase["myUser"];
  /** @deprecated Use `myUserSites` instead. This alias will be removed in the next major version. */
  readonly "my_user_sites": __DbViewBase["myUserSites"];
  /** @deprecated Use `visibleCohortAssignments` instead. This alias will be removed in the next major version. */
  readonly "visible_cohort_assignments": __DbViewBase["visibleCohortAssignments"];
  /** @deprecated Use `visibleCohortMembers` instead. This alias will be removed in the next major version. */
  readonly "visible_cohort_members": __DbViewBase["visibleCohortMembers"];
  /** @deprecated Use `visibleCohorts` instead. This alias will be removed in the next major version. */
  readonly "visible_cohorts": __DbViewBase["visibleCohorts"];
  /** @deprecated Use `visibleGroupRunLeaders` instead. This alias will be removed in the next major version. */
  readonly "visible_group_run_leaders": __DbViewBase["visibleGroupRunLeaders"];
  /** @deprecated Use `visibleGroupRunParticipants` instead. This alias will be removed in the next major version. */
  readonly "visible_group_run_participants": __DbViewBase["visibleGroupRunParticipants"];
  /** @deprecated Use `visibleGroupRuns` instead. This alias will be removed in the next major version. */
  readonly "visible_group_runs": __DbViewBase["visibleGroupRuns"];
  /** @deprecated Use `visibleOrientationCheckKeys` instead. This alias will be removed in the next major version. */
  readonly "visible_orientation_check_keys": __DbViewBase["visibleOrientationCheckKeys"];
  /** @deprecated Use `visibleOrientationChecks` instead. This alias will be removed in the next major version. */
  readonly "visible_orientation_checks": __DbViewBase["visibleOrientationChecks"];
  /** @deprecated Use `visibleOrientationStepLinks` instead. This alias will be removed in the next major version. */
  readonly "visible_orientation_step_links": __DbViewBase["visibleOrientationStepLinks"];
  /** @deprecated Use `visibleOrientationStepScripts` instead. This alias will be removed in the next major version. */
  readonly "visible_orientation_step_scripts": __DbViewBase["visibleOrientationStepScripts"];
  /** @deprecated Use `visibleOrientationSteps` instead. This alias will be removed in the next major version. */
  readonly "visible_orientation_steps": __DbViewBase["visibleOrientationSteps"];
  /** @deprecated Use `visibleOrientations` instead. This alias will be removed in the next major version. */
  readonly "visible_orientations": __DbViewBase["visibleOrientations"];
  /** @deprecated Use `visiblePendingUsers` instead. This alias will be removed in the next major version. */
  readonly "visible_pending_users": __DbViewBase["visiblePendingUsers"];
  /** @deprecated Use `visibleProjectAgents` instead. This alias will be removed in the next major version. */
  readonly "visible_project_agents": __DbViewBase["visibleProjectAgents"];
  /** @deprecated Use `visibleScriptActions` instead. This alias will be removed in the next major version. */
  readonly "visible_script_actions": __DbViewBase["visibleScriptActions"];
  /** @deprecated Use `visibleSiteRights` instead. This alias will be removed in the next major version. */
  readonly "visible_site_rights": __DbViewBase["visibleSiteRights"];
  /** @deprecated Use `visibleUserSites` instead. This alias will be removed in the next major version. */
  readonly "visible_user_sites": __DbViewBase["visibleUserSites"];
  /** @deprecated Use `visibleUsers` instead. This alias will be removed in the next major version. */
  readonly "visible_users": __DbViewBase["visibleUsers"];
};

type __TablesBase = __QueryBuilder<typeof tablesSchema.schemaType>;
export type Tables = __TablesBase & {
  /** @deprecated Use `exportResultEvent` instead. This alias will be removed in the next major version. */
  readonly "export_result_event": __TablesBase["exportResultEvent"];
  /** @deprecated Use `orgModuleUser` instead. This alias will be removed in the next major version. */
  readonly "org_module_user": __TablesBase["orgModuleUser"];
  /** @deprecated Use `adminSiteIds` instead. This alias will be removed in the next major version. */
  readonly "admin_site_ids": __TablesBase["adminSiteIds"];
  /** @deprecated Use `agentAssignmentProgress` instead. This alias will be removed in the next major version. */
  readonly "agent_assignment_progress": __TablesBase["agentAssignmentProgress"];
  /** @deprecated Use `agentAssignments` instead. This alias will be removed in the next major version. */
  readonly "agent_assignments": __TablesBase["agentAssignments"];
  /** @deprecated Use `agentGroupRunParticipants` instead. This alias will be removed in the next major version. */
  readonly "agent_group_run_participants": __TablesBase["agentGroupRunParticipants"];
  /** @deprecated Use `agentGroupRuns` instead. This alias will be removed in the next major version. */
  readonly "agent_group_runs": __TablesBase["agentGroupRuns"];
  /** @deprecated Use `agentOrientationChecks` instead. This alias will be removed in the next major version. */
  readonly "agent_orientation_checks": __TablesBase["agentOrientationChecks"];
  /** @deprecated Use `agentOrientationStepLinks` instead. This alias will be removed in the next major version. */
  readonly "agent_orientation_step_links": __TablesBase["agentOrientationStepLinks"];
  /** @deprecated Use `agentOrientationStepScripts` instead. This alias will be removed in the next major version. */
  readonly "agent_orientation_step_scripts": __TablesBase["agentOrientationStepScripts"];
  /** @deprecated Use `agentOrientationSteps` instead. This alias will be removed in the next major version. */
  readonly "agent_orientation_steps": __TablesBase["agentOrientationSteps"];
  /** @deprecated Use `agentOrientations` instead. This alias will be removed in the next major version. */
  readonly "agent_orientations": __TablesBase["agentOrientations"];
  /** @deprecated Use `agentScriptActions` instead. This alias will be removed in the next major version. */
  readonly "agent_script_actions": __TablesBase["agentScriptActions"];
  /** @deprecated Use `agentSiteRights` instead. This alias will be removed in the next major version. */
  readonly "agent_site_rights": __TablesBase["agentSiteRights"];
  /** @deprecated Use `agentUsers` instead. This alias will be removed in the next major version. */
  readonly "agent_users": __TablesBase["agentUsers"];
  /** @deprecated Use `assignableOrientations` instead. This alias will be removed in the next major version. */
  readonly "assignable_orientations": __TablesBase["assignableOrientations"];
  /** @deprecated Use `cohortAssignmentProgress` instead. This alias will be removed in the next major version. */
  readonly "cohort_assignment_progress": __TablesBase["cohortAssignmentProgress"];
  /** @deprecated Use `cohortCheckAnswers` instead. This alias will be removed in the next major version. */
  readonly "cohort_check_answers": __TablesBase["cohortCheckAnswers"];
  /** @deprecated Use `cohortProgress` instead. This alias will be removed in the next major version. */
  readonly "cohort_progress": __TablesBase["cohortProgress"];
  /** @deprecated Use `cohortStepMetrics` instead. This alias will be removed in the next major version. */
  readonly "cohort_step_metrics": __TablesBase["cohortStepMetrics"];
  /** @deprecated Use `groupRunCheckAnswers` instead. This alias will be removed in the next major version. */
  readonly "group_run_check_answers": __TablesBase["groupRunCheckAnswers"];
  /** @deprecated Use `leaderCheckKeys` instead. This alias will be removed in the next major version. */
  readonly "leader_check_keys": __TablesBase["leaderCheckKeys"];
  /** @deprecated Use `myAssignmentAttempts` instead. This alias will be removed in the next major version. */
  readonly "my_assignment_attempts": __TablesBase["myAssignmentAttempts"];
  /** @deprecated Use `myAssignmentProgress` instead. This alias will be removed in the next major version. */
  readonly "my_assignment_progress": __TablesBase["myAssignmentProgress"];
  /** @deprecated Use `myAssignmentStepMetrics` instead. This alias will be removed in the next major version. */
  readonly "my_assignment_step_metrics": __TablesBase["myAssignmentStepMetrics"];
  /** @deprecated Use `myAssignments` instead. This alias will be removed in the next major version. */
  readonly "my_assignments": __TablesBase["myAssignments"];
  /** @deprecated Use `myCheckAnswers` instead. This alias will be removed in the next major version. */
  readonly "my_check_answers": __TablesBase["myCheckAnswers"];
  /** @deprecated Use `myCheckKeys` instead. This alias will be removed in the next major version. */
  readonly "my_check_keys": __TablesBase["myCheckKeys"];
  /** @deprecated Use `myGroupRun` instead. This alias will be removed in the next major version. */
  readonly "my_group_run": __TablesBase["myGroupRun"];
  /** @deprecated Use `myGroupRunDetails` instead. This alias will be removed in the next major version. */
  readonly "my_group_run_details": __TablesBase["myGroupRunDetails"];
  /** @deprecated Use `myGroupRunLeaders` instead. This alias will be removed in the next major version. */
  readonly "my_group_run_leaders": __TablesBase["myGroupRunLeaders"];
  /** @deprecated Use `myGroupRunParticipants` instead. This alias will be removed in the next major version. */
  readonly "my_group_run_participants": __TablesBase["myGroupRunParticipants"];
  /** @deprecated Use `myNotifications` instead. This alias will be removed in the next major version. */
  readonly "my_notifications": __TablesBase["myNotifications"];
  /** @deprecated Use `myOrientationChecks` instead. This alias will be removed in the next major version. */
  readonly "my_orientation_checks": __TablesBase["myOrientationChecks"];
  /** @deprecated Use `mySessionCheckAnswers` instead. This alias will be removed in the next major version. */
  readonly "my_session_check_answers": __TablesBase["mySessionCheckAnswers"];
  /** @deprecated Use `mySessionProgress` instead. This alias will be removed in the next major version. */
  readonly "my_session_progress": __TablesBase["mySessionProgress"];
  /** @deprecated Use `mySessionTrainees` instead. This alias will be removed in the next major version. */
  readonly "my_session_trainees": __TablesBase["mySessionTrainees"];
  /** @deprecated Use `mySiteRights` instead. This alias will be removed in the next major version. */
  readonly "my_site_rights": __TablesBase["mySiteRights"];
  /** @deprecated Use `myUser` instead. This alias will be removed in the next major version. */
  readonly "my_user": __TablesBase["myUser"];
  /** @deprecated Use `myUserSites` instead. This alias will be removed in the next major version. */
  readonly "my_user_sites": __TablesBase["myUserSites"];
  /** @deprecated Use `visibleCohortAssignments` instead. This alias will be removed in the next major version. */
  readonly "visible_cohort_assignments": __TablesBase["visibleCohortAssignments"];
  /** @deprecated Use `visibleCohortMembers` instead. This alias will be removed in the next major version. */
  readonly "visible_cohort_members": __TablesBase["visibleCohortMembers"];
  /** @deprecated Use `visibleCohorts` instead. This alias will be removed in the next major version. */
  readonly "visible_cohorts": __TablesBase["visibleCohorts"];
  /** @deprecated Use `visibleGroupRunLeaders` instead. This alias will be removed in the next major version. */
  readonly "visible_group_run_leaders": __TablesBase["visibleGroupRunLeaders"];
  /** @deprecated Use `visibleGroupRunParticipants` instead. This alias will be removed in the next major version. */
  readonly "visible_group_run_participants": __TablesBase["visibleGroupRunParticipants"];
  /** @deprecated Use `visibleGroupRuns` instead. This alias will be removed in the next major version. */
  readonly "visible_group_runs": __TablesBase["visibleGroupRuns"];
  /** @deprecated Use `visibleOrientationCheckKeys` instead. This alias will be removed in the next major version. */
  readonly "visible_orientation_check_keys": __TablesBase["visibleOrientationCheckKeys"];
  /** @deprecated Use `visibleOrientationChecks` instead. This alias will be removed in the next major version. */
  readonly "visible_orientation_checks": __TablesBase["visibleOrientationChecks"];
  /** @deprecated Use `visibleOrientationStepLinks` instead. This alias will be removed in the next major version. */
  readonly "visible_orientation_step_links": __TablesBase["visibleOrientationStepLinks"];
  /** @deprecated Use `visibleOrientationStepScripts` instead. This alias will be removed in the next major version. */
  readonly "visible_orientation_step_scripts": __TablesBase["visibleOrientationStepScripts"];
  /** @deprecated Use `visibleOrientationSteps` instead. This alias will be removed in the next major version. */
  readonly "visible_orientation_steps": __TablesBase["visibleOrientationSteps"];
  /** @deprecated Use `visibleOrientations` instead. This alias will be removed in the next major version. */
  readonly "visible_orientations": __TablesBase["visibleOrientations"];
  /** @deprecated Use `visiblePendingUsers` instead. This alias will be removed in the next major version. */
  readonly "visible_pending_users": __TablesBase["visiblePendingUsers"];
  /** @deprecated Use `visibleProjectAgents` instead. This alias will be removed in the next major version. */
  readonly "visible_project_agents": __TablesBase["visibleProjectAgents"];
  /** @deprecated Use `visibleScriptActions` instead. This alias will be removed in the next major version. */
  readonly "visible_script_actions": __TablesBase["visibleScriptActions"];
  /** @deprecated Use `visibleSiteRights` instead. This alias will be removed in the next major version. */
  readonly "visible_site_rights": __TablesBase["visibleSiteRights"];
  /** @deprecated Use `visibleUserSites` instead. This alias will be removed in the next major version. */
  readonly "visible_user_sites": __TablesBase["visibleUserSites"];
  /** @deprecated Use `visibleUsers` instead. This alias will be removed in the next major version. */
  readonly "visible_users": __TablesBase["visibleUsers"];
};

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
const tablesBase: __TablesBase = __makeQueryBuilder(tablesSchema.schemaType);
export const tables: Tables = __withTableAccessorAliases(tablesBase, true) as Tables;

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = Omit<__EventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = Omit<__ReducerEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = Omit<__SubscriptionEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for error events. */
export type ErrorContext = Omit<__ErrorContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  declare db: DbView;

  constructor(config: __DbConnectionConfig<typeof REMOTE_MODULE>) {
    super(config);
    this.db = __withTableAccessorAliases(this.db) as DbView;
  }

  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

